import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    padding-top: ${theme.padding.big};
    padding-bottom: ${theme.padding.big};
    border-radius: ${theme.borderRadius.big};
    background-color: ${theme.colors.grey.main};
  `}
`;

export const TopContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${({ theme }) => css`
    padding: 0 ${theme.padding.big};
    margin-bottom: ${theme.padding.big};
  `}
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  ${({ theme }) => css`
    gap: ${theme.padding.small};
    padding: 0 ${theme.padding.big};
  `}
`;

export const BottomContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;

  button {
    width: 100%;
  }

  ${({ theme }) => css`
    gap: ${theme.padding.default};
    padding: 0 ${theme.padding.big};
    margin-top: ${theme.padding.biggest};
    background-color: ${theme.colors.grey.main};
  `}
`;
